import {
  LOAD_PARTS_REQUEST,
  LOAD_PARTS_SUCCESS,
  LOAD_PARTS_ERROR
} from 'redux/actions';

import { createPart } from 'models/Part';
// default states
const partsState = {
  loadedParts: [],
  isFetching: false,
  error: false
};

// helper to add connections to the parts
const applyConnections = (partsCollection, connections) => partsCollection.map((part) => {
  if (part.type !== 'accessory') {
    return part;
  }
  // add 'collections' to the part...
  const accessoryConnections = connections.accessories[part.group];
  if (!accessoryConnections) {
    return part;
  }
  const dataBlock = accessoryConnections
    .find(block => block.parts === part.partNo || block.parts.includes(part.partNo));
  if (dataBlock) {
    return createPart({
      ...part,
      connections: dataBlock
    });
  }
  return part;
});

// reducers
function parts(state = partsState, action) {
  const { loadedParts, loadedConnections, error } = action;
  switch (action.type) {
    case LOAD_PARTS_REQUEST:
      return {
        ...state,
        isFetching: true
      };
    case LOAD_PARTS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: false,
        loadedParts: applyConnections(
          loadedParts.map(part => createPart(part)),
          loadedConnections
        )
      };
    case LOAD_PARTS_ERROR:
      return {
        ...state,
        isFetching: false,
        error
      };
    default:
      return state;
  }
}

export default parts;
